var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/modules/web.immediate.js
// module id = 436
// module chunks = 0